import moment from 'moment';
import { Link } from 'react-router-dom';
import { openDSWindow } from '../../../helpers/Window';

export const getLanguage = (lng = '') => {
  if (lng.includes('en')) {
    return 'en';
  }

  if (lng.includes('fr')) {
    return 'fr';
  }
}

export const redirect = ({ type, id, mod, mode }) => {
  const viewMode = type === 'document' ? 'viewdd' : 'view';

  if (mode === 'proxy') {
    openDSWindow({
      url: `/proxy/${mod}/${viewMode}/${type}/${id}`,
      name: 'Linking Window Proxy',
    })
    return
  }

  return `/app/${mod}/${viewMode}/${type}/${id}`;
};

export const getColumns = ({ t, redirect = () => '', mod, language, mode = 'app' }) => [
  {
    title: 'ID',
    dataIndex: 'datastakeId',
    key: 'datastakeId',
    render: (id, all) => mode === 'proxy' ? (
      <a onClick={() => redirect({ id, type: all.type, mod, mode })} href="#">
        {id}
      </a>
    ) : (
      <Link to={redirect({ id, type: all.type, mod, mode })} target="_blank">
        {id}
      </Link>
    ),
  },
  {
    title: t('Name'),
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: t('Type'),
    dataIndex: 'type',
    key: 'type',
    render: (type) => t(type),
  },
  {
    title: t('Nature'),
    dataIndex: 'usedAs',
    key: 'usedAs',
    render: (usedAs) => {
      if (!usedAs) {
        return '';
      }

      const lng = getLanguage(language);
      const val = usedAs[lng]

      if (val) {
        if (typeof val === 'string') {
          return val;
        }

        if (typeof val === 'object') {
          return Object.values(val)[0];
        }
      }
      return '';
    }
  },
  {
    title: t('LinkedSubjects::lastUpdate'),
    dataIndex: 'updateAt',
    key: 'updateAt',
    render: (updatedAt) =>
      moment(updatedAt).format('DD MMM YYYY'),
  },
];
